import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import StatsCounter from "@/components/StatsCounter";
import Marquee from "@/components/Marquee";
import DealersSection from "@/components/DealersSection";
import ProductsGrid from "@/components/ProductsGrid";
import TrustRow from "@/components/TrustRow";
import VideoWall from "@/components/VideoWall";
import Testimonials from "@/components/Testimonials";
import Gallery from "@/components/Gallery";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { scrollToId } from "@/lib/api";
import InstagramWall from "@/components/InstagramWall";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToId(location.hash.slice(1)), 800);
      return () => clearTimeout(t);
    }
  }, [location]);

  return (
    <div data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <StatsCounter />
        <Marquee />
       <section id="dealers" className="mx-auto max-w-[1400px] px-5 pt-16 pb-24 sm:px-8 sm:pt-24 sm:pb-32">
        <DealersSection />
        </section>
        <section id="products" className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32">
          <ProductsGrid />
        </section>
        <section id="why" className="mx-auto max-w-[1400px] px-5 pb-24 sm:px-8 sm:pb-32">
          <TrustRow />
        </section>
        <section id="stories" className="border-y border-ink/10 bg-white">
          <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32">
            <VideoWall />
            <Testimonials />
          </div>
        </section>
        <section id="instagram" className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32">
          <InstagramWall />
        </section>
        <section id="projects" className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32">
          <Gallery />
        </section>
        <section id="contact" className="border-t border-line">
          <div className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32">
            <Contact />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
